import { useSetting } from './useSetting'

const defaultTokens = { access: null, refresh: null }

export const useAuthTokens = () => {
  return useSetting('token', defaultTokens)
}
